
const scopes = [
    {
        name: 'Accounts',
        description: 'Accounts related scopes',
        scopes: [
            {
                key: 'read_accounts',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre los clientes.'
            }, 
            {
                key: 'write_accounts',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de los clientes'
            },
            {
                key: 'write_account_status',
                name: 'Account status',
                description: 'Este scope permite activar o desactivar una cuenta y verificarla o quitarle la verificación, incluida la compañía.'
            },
            {
                key: 'write_reset_account',
                name: 'Reset account',
                description: 'Este scope permite restablecer el estado de activación de una cuenta (solo desarrollo o cuenta de prueba en producción).'
            },
            {
                key: 'read_sales_commissions',
                name: 'Sales commissions',
                description: 'Este scope permite ver el dashboard de comisiones de ventas. Sin el scope de salespeople, el usuario solo ve su cartera y la de sus subordinados.'
            },
            {
                key: 'read_sales_overview',
                name: 'Sales overview',
                description: 'Este scope permite ver el tablero de overview del equipo de ventas (roster y KPIs), independiente del dashboard de comisiones.'
            },
            {
                key: 'read_customer_success',
                name: 'Customer success',
                description: 'Este scope permite ver el dashboard de customer success (LTV, GRR, NRR, churn y comisiones). Sin este scope, un representante solo ve su propia cartera.'
            },
            {
                key: 'write_inbound_leads',
                name: 'Inbound leads',
                description: 'Este scope permite activar o pausar, por el día en curso, a los representantes de inbound para que reciban o no nuevos leads.'
            }
        ]
    },
    {
        name: 'Account Owners',
        description: 'Account Owners related scopes',
        scopes: [
            {
                key: 'read_account_owners',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre los propietarios de cuenta.'
            },
            {
                key: 'write_account_owners',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de los propietarios de cuenta.'
            }
        ]
    },    
    {
        name: 'Addresses',
        description: 'Addresses related scopes',
        scopes: [
            {
                key: 'read_addresses',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre las direcciones de los clientes.'
            }, 
            {
                key: 'write_addresses',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a las direcciones de los clientes'
            }
        ]
    },
    {
        name: 'Activations',
        description: 'Activations related scopes',
        scopes: [
            {
                key: 'read_activations',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre las activaciones del procesador de Ecart Pay.'
            },
            {
                key: 'write_activations',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a la información y estado de las activaciones del procesador de Ecart Pay.'
            }
        ]
    },
    {
        name: 'Activity',
        description: 'Activity related scopes',
        scopes: [
            {
                key: 'read_activity',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre la actividad.'
            },
            {
                key: 'read_gateway_code',
                name: 'Read gateway code',
                description: 'Este scope permite a los usuarios incluir el campo gateway_code al descargar el reporte de actividad.'
            }
        ]
    },
    {
        name: 'AI Conversations',
        description: 'AI Conversations related scopes',
        scopes: [
            {
                key: 'read_ai_conversations',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre las conversaciones de IA.'
            }
        ]
    },
    {
        name: 'Admins',
        description: 'Admins related scopes',
        scopes: [
            {
                key: 'read_admins',
                name: 'Read',
                description: 'Este scope permite leer información de los administradores.'
            },
            {
                key: 'write_admins',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar operaciones de escritura y modificación de los datos de los administradores.'
            }
        ]
    },
    {
        name: 'Affiliations',
        description: 'Affiliations related scopes',
        scopes: [
            {
                key: 'read_affiliations',
                name: 'Read',
                description: 'Este scope permite leer información de las afiliaciones.'
            },
            {
                key: 'write_affiliations',
                name: 'Write',
                description: 'Este scope permite a los administradores crear, ligar y actualizar afiliaciones, y gestionar las solicitudes de afiliación.'
            }
        ]
    },
    {
        name: 'Acquirers',
        description: 'Acquirers related scopes',
        scopes: [
            {
                key: 'read_acquirers',
                name: 'Read',
                description: 'Este scope permite leer los adquirientes.'
            },
            {
                key: 'write_acquirers',
                name: 'Write',
                description: 'Este scope permite crear, actualizar y eliminar adquirientes.'
            }
        ]
    },
    {
        name: 'Affiliation catalog',
        description: 'Affiliation catalog related scopes',
        scopes: [
            {
                key: 'read_affiliation_catalogs',
                name: 'Read',
                description: 'Este scope permite leer las plantillas del catálogo de afiliaciones.'
            },
            {
                key: 'write_affiliation_catalogs',
                name: 'Write',
                description: 'Este scope permite crear, actualizar y eliminar plantillas del catálogo de afiliaciones.'
            }
        ]
    },
    {
        name: 'Audit Logs',
        description: 'Audit logs related scopes',
        scopes: [
            {
                key: 'read_audit_logs',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer el historial de cambios de los documentos de la base de datos.'
            }
        ]
    },
    {
        name: 'Automatic Dispersion',
        description: 'Automatic Dispersion related scopes',
        scopes: [
            {
                key: 'write_automatic_dispersion',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de la dispersión automática.'
            }
        ]
    },
    {
        name: 'Billings',
        description: 'Billings related scopes',
        scopes: [
            {
                key: 'read_billings',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre las facturaciones.'
            },
            {
                key: 'write_billings',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de las facturaciones.'
            }
        ]
    },
    {
        name: 'Bin Manager',
        description: 'Bin related account',
        scopes: [
            {
                key: 'read_bin_manager',
                name: 'Read',
                description: 'Este scope permite a los administradores ver la informacion del los bins de las cuentas.'
            }
        ]
    },
    {
        name: 'Blacklisted Cards',
        description: 'Blacklisted cards related scopes',
        scopes: [
            {
                key: 'read_blacklisted_cards',
                name: 'Read',
                description: 'This scope allows admins to view blacklisted card information.'
            },
            {
                key: 'write_blacklisted_cards',
                name: 'Write',
                description: 'This scope allows admins to modify blacklisted card information.'
            }
        ]
    },
    {
        name: 'Notification campaigns',
        description: 'Operational notification campaigns sent through Novu',
        scopes: [
            {
                key: 'read_notification_campaigns',
                name: 'Read',
                description: 'This scope allows admins to view notification campaign history.'
            },
            {
                key: 'write_notification_campaigns',
                name: 'Write',
                description: 'This scope allows admins to preview and send operational notification campaigns.'
            }
        ]
    },
    {
        name: 'Chargebacks',
        description: 'Chargebacks related scopes',
        scopes: [
            {
                key: 'read_chargebacks',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre los contracargos de los clientes.'
            },
            {
                key: 'write_chargebacks',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones de los datos de los contracargos.'
            }
        ]
    },
    {
        name: 'Dashboard Mongo DB',
        description: 'Dashboard related scopes',
        scopes: [
            {
                key: 'read_dashboard_mongodb',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre el dashboard.'
            }
        ]
    },
    {
        name: 'Direct Debits',
        description: 'Direct Debits related scopes',
        scopes: [
            {
                key: 'read_direct_debits',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre los direct debits.'
            },
            {
                key: 'write_direct_debits',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de los direct debits.'
            }
        ]
    },
    {
        name: 'Subscriptions',
        description: 'Subscriptions related scopes',
        scopes: [
            {
                key: 'read_subscriptions',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre las suscripciones.'
            },
            {
                key: 'write_subscriptions',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de las suscripciones.'
            }
        ]
    },
    {
        name: 'Gateways',
        description: 'Gateways related scopes',
        scopes: [
            {
                key: 'read_gateways',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre los gateways.'
            },
            {
                key: 'write_gateways',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de los gateways.'
            }
        ]
    },
    {
        name: 'General Rules',
        description: 'General rules related scopes',
        scopes: [
            {
                key: 'write_general_rules',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a las reglas generales.'
            }
        ]
    },
    {
        name: 'Invoices',
        description: 'Invoices related scopes',
        scopes: [
            {
                key: 'read_invoices',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre los invoices de los clientes.'
            },
            {
                key: 'write_invoices',
                name: 'Write',
                description: 'Este scope permite a los usuarios timbrar los invoices de los clientes.'
            }
        ]
    },
    {
        name: 'Integrations',
        description: 'Integrations related scopes',
        scopes: [
            {
                key: 'read_integrations',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre las integraciones.'
            },
            {
                key: 'write_integrations',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de las integraciones.'
            },
            {
                key: 'write_integration_access',
                name: 'Access control',
                description: 'Este scope permite revocar el acceso de integraciones de Shopify y WooCommerce y volver a desbloquearlas.'
            }
        ]
    },
    {
        name: 'Leads',
        description: 'Leads related scopes',
        scopes: [
            {
                key: 'read_leads',
                name: 'Read',
                description: 'Este scope permite leer información de los leads.'
            },
            {
                key: 'write_leads',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar operaciones de escritura y modificación de los datos de los leads.'
            },
            {
                key: 'approve_quotes',
                name: 'Approve quotes',
                description: 'Este scope permite aprobar o rechazar cotizaciones con tasas por debajo de la tarifa sugerida.'
            },
            {
                key: 'write_own_leads',
                name: 'Own leads',
                description: 'Para vendedores: permite crear leads y ver, editar e invitar únicamente los leads que tiene asignados.'
            },
            {
                key: 'write_own_quotes',
                name: 'Own quotes',
                description: 'Para vendedores: permite crear cotizaciones para sus leads y ver, editar y descargar únicamente las cotizaciones que creó.'
            }
        ]
    },
    {
        name: 'Limits',
        description: 'Limits related scopes',
        scopes: [
            {
                key: 'read_limits',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre los límites.'
            },
            {
                key: 'write_limits',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los límites.'
            }
        ]
    },
    {
        name: 'Payment Methods',
        description: 'Payment Methods related scopes',
        scopes: [
            {
                key: 'write_payment_methods',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los métodos de pago.'
            }
        ]
    },
    {
        name: 'Payouts',
        description: 'Payouts related scopes',
        scopes: [
            {
                key: 'read_payouts',
                name: 'Read',
                description: 'Este scope permite leer información de los pagos a los clientes.'
            }
        ]
    },
    {
        name: 'Pricings',
        description: 'Pricings related scopes',
        scopes: [
            {
                key: 'read_pricings',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre los precios.'
            },
            {
                key: 'write_pricings',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los precios.'
            }
        ]
    },
    {
        name: 'Commission Schemes',
        description: 'Installment commission scheme access',
        scopes: [
            {
                key: 'read_commission_schemes',
                name: 'Read',
                description: 'Allows users to view installment commission schemes.'
            },
            {
                key: 'write_commission_schemes',
                name: 'Write',
                description: 'Allows admins to update installment commission percentages.'
            }
        ]
    },
    {
        name: 'Partner rates',
        description: 'Partner referral rate templates',
        scopes: [
            {
                key: 'read_partner_rates',
                name: 'Read',
                description: 'Read partner rate packages on a partner account.'
            },
            {
                key: 'write_partner_rates',
                name: 'Write',
                description: 'Create, edit, approve, reject, archive, and clone partner rate packages.'
            }
        ]
    },
    {
        name: 'Profiles',
        description: 'Profiles related scopes',
        scopes: [
            {
                key: 'read_profiles',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre los perfiles.'
            },
            {
                key: 'write_profiles',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de los perfiles.'
            }
        ]
    },
    {
        name: 'Rating',
        description: 'Rating related account',
        scopes: [
            {
                key: 'write_ratings',
                name: 'Write',
                description: 'Este scope permite a los administradores modificar el rating de las cuentas.'
            }
        ]
    },
    {
        name: 'Refunds',
        description: 'Refunds related scopes',
        scopes: [
            {
                key: 'read_refunds',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre los rembolsos'
            },
            {
                key: 'write_refunds',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de los rembolsos.'
            },
            {
                key: 'write_refunds_admin',
                name: 'Write Admin',
                description: 'Este scope permite a los administradores realizar modificaciones a los datos de los rembolsos.'
            }
        ]
    },
    {
        name: 'Reports',
        description: 'Reports related scopes',
        scopes: [
            {
                key: 'read_reports',
                name: 'Read',
                description: 'Este scope permite a los usuarios generar y descargar reportes.'
            }
        ]
    },
    {
        name: 'Summary',
        description: 'Transaction summary related scopes',
        scopes: [
            {
                key: 'write_summary',
                name: 'Write',
                description: 'Este scope permite recalcular el resumen de transacciones de una cuenta.'
            }
        ]
    },
    {
        name: 'Report Accounts',
        description: 'Reports related scopes',
        scopes: [
            {
                key: 'report_accounts',
                name: 'Read',
                description: 'Este scope permite a los usuarios descargar los datos de los clientes'
            },
        ]
    },
    {
        name: 'Risk Analysis',
        description: 'Risk Analysis related scopes',
        scopes: [
            {
                key: 'write_risk_analysis',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar acciones de rechazo y bypass en el análisis de riesgo de las activaciones.'
            }
        ]
    },
    {
        name: 'Risks',
        description: 'Risks related scopes',
        scopes: [
            {
                key: 'read_risks',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre los riesgos.'
            },
            {
                key: 'write_risks',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de los riesgos.'
            }
        ]
    },
    {
        name: 'Business Reviews',
        description: 'Business reviews related scopes',
        scopes: [
            {
                key: 'read_business_reviews',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre las revisiones de negocio de alto riesgo.'
            },
            {
                key: 'write_business_reviews',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a las revisiones de negocio de alto riesgo.'
            }
        ]
    },
    {
        name: 'Rules',
        description: 'Risks related scopes',
        scopes: [
            {
                key: 'read_rules',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre las reglas de riesgo.'
            },
            {
                key: 'write_rules',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar operaciones de lectura y escritura de información sobre reglas de riesgo.'
            }
        ]
    },
    {
        name: 'Transactions',
        description: 'Transactions related scopes',
        scopes: [
            {
                key: 'read_transactions',
                name: 'Read',
                description: 'Este scope permite leer información de las transacciones de los clientes.'
            },
            {
                key: 'write_transactions',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de las transacciones.'
            }
        ]
    },
    {
        name: 'Transfers',
        description: 'Transfers related scopes',
        scopes: [
            {
                key: 'read_transfers',
                name: 'Read',
                description: 'Este scope permite leer información de las transferencias de los clientes.'
            },
        ]
    },
    {
        name: 'Tendencys Risk',
        description: 'Opens the Tendencys Risk portal from admin',
        scopes: [
            {
                key: 'access_tendencys_risk',
                name: 'Access',
                description: 'This scope allows admins to open Tendencys Risk already signed in.'
            }
        ]
    },
    {
        name: 'Arena',
        description: 'Bull Arena queue monitoring scopes',
        scopes: [
            {
                key: 'access_arena',
                name: 'Access',
                description: 'This scope allows admins to open Arena and manage worker queues.'
            }
        ]
    },
    {
        name: 'Webhook Logs',
        description: 'Webhook logs related scopes',
        scopes: [
            {
                key: 'read_webhookslogs',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer los registros de eventos de webhooks.'
            },
            {
                key: 'write_webhookslogs',
                name: 'Write',
                description: 'Este scope permite a los usuarios reintentar el envío de webhooks fallidos.'
            }
        ]
    },
    {
        name: 'Whitelist',
        description: 'Whitelist related scopes',
        scopes: [
            {
                key: 'read_whitelist',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre la lista blanca.'
            },
            {
                key: 'write_whitelist',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a la lista blanca.'
            }
        ]
    },
    {
        name: 'Withdrawals',
        description: 'Withdrawals related scopes',
        scopes: [
            {
                key: 'read_withdrawals',
                name: 'Read',
                description: 'Este scope permite leer información de los retiros de los clientes.'
            },
            {
                key: 'block_withdrawals',
                name: 'Block',
                description: 'Este scope permite leer información de los retiros y bloquear retiros con un comentario obligatorio.'
            },
            {
                key: 'write_withdrawals',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de los retiros.'
            },
        ]
    },
    {
        name: 'Timelines',
        description: 'Timelines related scopes',
        scopes: [
            {
                key: 'read_timelines',
                name: 'Read',
                description: 'Este scope permite leer información de los timelines de los diferentes recursos.'
            }
        ]
    },
    {
        name: 'Commercial Partners',
        description: 'Commercial Partners related scopes',
        scopes: [
            {
                key: 'write_commercial_partner',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar modificaciones a los datos de los partners de una cuenta.'
            }
        ]
    },
    {
        name: 'Terminals',
        description: 'Terminals related scopes',
        scopes: [
            {
                key: 'read_pos_information',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre las terminales.'
            },
            {
                key: 'write_pos_information',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar operaciones de escritura y modificación en los datos de las terminales.'
            },
            {
                key: 'write_admin_pos_information',
                name: 'Write Admin',
                description: 'Este scope permite a los usuarios desvincular la cuenta asociada a una terminal.'
            }
        ]
    },
    {
        name: 'Terminal Orders',
        description: 'Terminal Orders related scopes',
        scopes: [
            {
                key: 'read_terminal_orders',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre las ordenes de terminales.'
            },
            {
                key: 'write_terminal_orders',
                name: 'Write',
                description: 'Este scope permite a los usuarios realizar operaciones de escritura y modificación en las ordenes de terminales.'
            }
        ]
    },
    {
        name: 'Reconciliations',
        description: 'Reconciliations related scopes',
        scopes: [
            {
                key: 'read_reconciliations',
                name: 'Read',
                description: 'Este scope permite a los usuarios usar la herramienta de conciliaciones (Oxxo, Clubpago, EcartPay) y consultar el desglose por periodo.'
            },
            {
                key: 'write_reconciliations',
                name: 'Write',
                description: 'Este scope permite ejecutar conciliaciones (subir EDC/estado de cuenta, contrastar contra transacciones, settle del día y archivar el archivo en S3).'
            }
        ]
    },
    {
        name: 'Charts',
        description: 'Charts related scopes',
        scopes: [
            {
                key: 'read_charts',
                name: 'Access',
                description: 'Este scope permite entrar a la aplicación Charts'
            },
            {
                key: 'read_charts_tv',
                name: 'TV mode',
                description: 'Este scope permite abrir el modo TV en Charts. El contenido de TV es un layout fijo y restringido.'
            },
            {
                key: 'read_charts_product_usage',
                name: 'Product usage',
                description: 'Este scope permite ver la sección Product usage en Charts.'
            },
            {
                key: 'read_charts_salespeople',
                name: 'Salespeople',
                description: 'Este scope permite ver la sección Salespeople en Charts.'
            },
            {
                key: 'read_charts_partners',
                name: 'Partners',
                description: 'Este scope permite ver la sección Partners en Charts.'
            },
            {
                key: 'read_charts_total_sales',
                name: 'Total sales',
                description: 'Este scope permite ver la sección Total sales en Charts.'
            },
            {
                key: 'read_charts_customers',
                name: 'Customers',
                description: 'Este scope permite ver la sección Customers en Charts.'
            },
            {
                key: 'read_charts_pricing',
                name: 'Pricing',
                description: 'Este scope permite ver la sección Pricing en Charts.'
            },
            {
                key: 'read_charts_customer_liability',
                name: 'Owed to customers',
                description: 'This scope allows viewing Owed to customers in Charts.'
            },
            {
                key: 'read_charts_chargebacks',
                name: 'Chargebacks',
                description: 'This scope allows viewing Chargebacks in Charts.'
            },
            {
                key: 'read_charts_refunds',
                name: 'Refunds',
                description: 'This scope allows viewing Refunds in Charts.'
            },
            {
                key: 'read_charts_withdrawals',
                name: 'Withdrawals',
                description: 'This scope allows viewing Withdrawals in Charts.'
            },
            {
                key: 'read_charts_accounts',
                name: 'Accounts',
                description: 'Este scope permite ver la sección Accounts en Charts.'
            },
            {
                key: 'read_charts_acceptance_rate',
                name: 'Acceptance rate',
                description: 'Este scope permite ver la sección Acceptance rate en Charts.'
            },
            {
                key: 'read_charts_marketing',
                name: 'Marketing',
                description: 'This scope allows viewing the Marketing section in Charts.'
            },
            {
                key: 'read_charts_engineering',
                name: 'Engineering',
                description: 'This scope allows viewing developer performance metrics in Charts.'
            },
            {
                key: 'read_charts_engineering_own',
                name: 'Engineering (own metrics)',
                description: 'This scope allows a developer to view the team totals and their own metrics in Charts, but not other developers. Give Charts access too, and link the developer to this admin email in Engineering settings.'
            },
            {
                key: 'write_charts_engineering',
                name: 'Engineering settings',
                description: 'This scope allows managing the developer roster, repositories, PR classification and GitHub sync.'
            }
        ]
    },
    {
        name: 'Prohibited Products',
        description: 'Prohibited Products related scopes',
        scopes: [
            {
                key: 'read_prohibited_products',
                name: 'Read',
                description: 'Este scope permite a los usuarios leer información sobre los productos prohibidos.'
            },
            {
                key: 'write_prohibited_products',
                name: 'Write',
                description: 'Este scope permite a los usuarios crear, editar y activar o inactivar los productos prohibidos.'
            }
        ]
    },
];

export default scopes;